import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  cardContentWrapperCenter:{},
  performanceRadioGroupDisabled:{},
  title: {
    fontWeight: 500,
    color: "#242A38",
    marginBottom: 0,
    padding: theme.spacing(0.5, 3),
    fontSize: 14,
  },
  tabs: {
    padding: 0,
    "& .MuiButtonBase-root": {
      textTransform: "none",
      fontSize: 12,
      color: "#8F8F8F",
      padding: "0",
      marginRight: theme.spacing(1.5),
      marginBottom: "0.4em",
      minWidth: "auto",
      [theme.breakpoints.up("sm")]: {
        fontSize: 16,
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: "1.35em",
        marginRight: "2.5em",
      },
    },
    "& .MuiButtonBase-root.Mui-selected": {
      color: "#242A38",
    },
    "& .MuiTabs-indicator": {
      height: "4px",
    },
  },
  tabPanel: {
    marginTop: theme.spacing(3),
    "& > .MuiBox-root": {
      margin: 0,
    },
  },
  performanceCheckboxContainer: {
    margin: theme.spacing(1, 0, 5),
  },
  performanceRadioGroup: {
    margin: theme.spacing(0, -2.5),
  },
  speedRangeCard: {
    position: "relative",
    margin: theme.spacing(1),
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(1.5),
    },
    [theme.breakpoints.up("lg")]: {
      margin: theme.spacing(2, 2.5),
    },
    "& > .MuiRadio-root": {
      position: "absolute",
      opacity: 0,
      zIndex: 1,
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
    },
  },
  speedRangeCardInner: {
    border: "1px solid rgba(241, 242, 246, 1)",
    borderRadius: 40,
    cursor: "pointer",
    width: 115,
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
      width: 150,
    },
    [theme.breakpoints.up("lg")]: {
      width: 160,
    },
  },
  speedRangeCardSelected: {
    border: "1px solid rgba(249, 208, 55, 1)",
    boxShadow: "2px 2px 9px 2px rgba(255, 213, 48, 0.37)",
  },
  speedLimit: {
    width: 50,
    minWidth: 50,
    flex: "0 0 50px",
    height: 50,
    borderRadius: 50,
    border: "3px solid rgba(212, 4, 4, 1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    lineHeight: 1.2,
    [theme.breakpoints.up("sm")]: {
      width: 70,
      minWidth: 70,
      flex: "0 0 70px",
      height: 70,
      borderRadius: 70,
    },
    [theme.breakpoints.up("lg")]: {
      width: 70,
      minWidth: 70,
      flex: "0 0 70px",
      height: 70,
      borderRadius: 70,
    },
  },
  speedLimitValue: {
    fontSize: 15,
    fontWeight: 700,
    [theme.breakpoints.up("sm")]: {
      fontSize: 20,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 25,
    },
  },
  speedLimitUnit: {
    color: "rgb(152, 152, 152)",
    fontSize: 9,
    [theme.breakpoints.up("sm")]: {
      fontSize: 11,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 13,
    },
  },
  maxSpeed: {
    color: "rgb(152, 152, 152)",
    fontSize: 9,
    padding: theme.spacing(0, 0.5, 0, 1.25),
    lineHeight: 1.2,
    [theme.breakpoints.up("sm")]: {
      fontSize: 11,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 13,
    },
  },
  maxSpeedValue: {
    color: "rgb(0, 0, 0)",
    fontSize: 10,
    fontWeight: 700,
    [theme.breakpoints.up("sm")]: {
      fontSize: 12,
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: 15,
    },
  },
  tableCellValue: {
    fontWeight: 500,
    color: "#242A38",
    padding: theme.spacing(0.5, 3),
    fontSize: 14,
    "& a": {
      color: "rgba(0, 0, 0, 0.87)",
      textDecoration: "unset",
    },
  },
  eventTimeValue: {
    fontWeight: 500,
    color: "rgba(163, 171, 182, 1)",
    fontSize: 12,
  },
  bgWhite: {
    backgroundColor: "rgba(255, 255, 255, 1)",
  },
  cardContentWrapper: {
    overflow: "auto",
  },
  cardContent: {
    minWidth: 700,
  },
  headerSubNote: {
    textAlign: "right",
    color: "rgb(175 179 187)",
    marginBottom: 0,
    fontSize: 10,
    fontWeight: 500,
    [theme.breakpoints.up("sm")]: {
      fontSize: 15,
      fontWeight: 400,
    },
  },
  cardContentDisabled: {
    pointerEvents: "none",
  },
  graphDisabled: {
    pointerEvents: "none",
  },
  speedLimitDisabled: {
    color: "rgb(241, 242, 246)!important",
    border: "3px solid rgb(241, 242, 246)!important",
  },
  maxSpeedDisabled: {
    color: "rgb(241, 242, 246)!important",
  },
  maxSpeedValueDisabled: {
    color: "rgb(241, 242, 246)!important",
  },
  speedLimitUnitDisabled: {
    color: "rgb(241, 242, 246)!important",
  },
  speedRangeCardSelectedDisabled: {
    border: "1px solid rgb(241, 242, 246)!important",
    boxShadow: "unset!important",
  },
  loadingContainer: {
    padding: "1.6em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  reportGraph:{

  },
}));
